import { CustomPicture, CustomSource } from "~/components/ui/CustomPicture"
import type { ImageWidget } from "~/types/widgets"

export interface Props {
  /**
   * @title Imagem desktop
   */
  desktop: ImageWidget

  /**
   * @title Altura da imagem desktop (apenas número)
   * @description Se não for passada altura da imagem desktop, será renderizada a altura default (137)
   */
  heightDesktop?: number

  /**
   * @title Imagem mobile
   */
  mobile: ImageWidget

  /**
   * @title Altura da imagem mobile (apenas número)
   * @description Se não for passada altura da imagem mobile, será renderizada a altura default (137)
   */
  heightMobile?: number

  /**
   * @title Texto alternativo das imagens
   */
  alt: string
}

export default function BrandBanner({ desktop, mobile, heightDesktop, heightMobile, alt }: Props) {
  if (!desktop || !mobile || !alt) return null

  return (
    <div className='flex items-center w-full max-w-[1818px] mt-3 mx-auto px-2'>
      <CustomPicture preload className='w-full h-full overflow-hidden rounded-xl'>
        <CustomSource
          media='(max-width: 1023px)'
          src={mobile}
          width={768}
          height={heightMobile ?? 137}
          fetchPriority='high'
          quality='high'
          factors={[0.5, 1]}
        />
        <CustomSource
          media='(min-width: 1024px)'
          src={desktop}
          width={1802}
          height={heightDesktop ?? 137}
          fetchPriority='high'
          quality='high'
          factors={[0.5, 0.75, 1]}
        />
        <img
          loading='eager'
          src={desktop}
          alt={alt}
          className='w-full h-full object-cover'
        />
      </CustomPicture>
    </div>
  )
}
